export const MAIL_AQUA_SECURITY = 'security@aqua.network';
export const MAIL_AQUA_HELLO = 'hello@aqua.network';
export const MAIL_AQUA_PRIVACY = 'privacy@aqua.network';
